import { action, thunk, computed } from 'easy-peasy';
import { mapProductReviews, mapProductReviewsSummary } from './mappers';
import { REVIEWS_PER_PAGE, EMPTY_REVIEWS_SUMMARY } from './types/products';
import ProductsModel from './types/ProductsModel';
import { api } from '../../common/api';

const productsModel: ProductsModel = {
  // state
  reviews: undefined,
  reviewsSummary: EMPTY_REVIEWS_SUMMARY,

  // computed
  hasMoreReviews: computed(state => {
    return !!state.reviews && state.reviews.page * REVIEWS_PER_PAGE < state.reviews.total;
  }),

  // actions
  loadProductReviews: action((state, payload) => {
    state.reviews = payload;
  }),
  loadProductReviewsSummary: action((state, payload) => {
    state.reviewsSummary = payload;
  }),

  unloadProductReviews: action(state => {
    state.reviews = undefined;
  }),
  unloadProductReviewsSummary: action(state => {
    state.reviewsSummary = EMPTY_REVIEWS_SUMMARY;
  }),

  // thunk
  getProductReviews: thunk(async (actions, payload) => {
    const response = await api.post('api/v1/product/reviews', { ...payload }).catch(() => {});

    if (!response) {
      return;
    }

    await actions.loadProductReviews(mapProductReviews(response.data));
  }),
  getProductReviewsSummary: thunk(async (actions, payload) => {
    const response = await api
      .post('api/v1/product/reviews/summary', { ...payload })
      .catch(() => {});

    if (!response) {
      return;
    }

    await actions.loadProductReviewsSummary(mapProductReviewsSummary(response.data.data));
  }),
};

export default productsModel;
